export default __webpack_public_path__ + "static/media/bacterie.dbfb37ff.png";